<app-toaster></app-toaster>
<app-loading-spinner></app-loading-spinner>
<app-mobile-cart-items></app-mobile-cart-items>
<router-outlet></router-outlet>